module.exports = __webpack_public_path__ + "img/logo.d70e5484.png";